import {
  Card,
  CardContent,
  Divider,
  Grid,
  Table,
  TableBody,
  TableContainer,
} from "@material-ui/core";
import { KisshtDialog } from "components/custom/KisshtDialog";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import KisshtButton from "components/ui/KisshtButton";
import { RobotFont } from "components/ui/RobotFont";
import Spin from "components/ui/Spin";
import { VerifyPayment } from "pages/Payments/dialogs/VerifyPayment";
import React, { useCallback, useState } from "react";
import { verifySubUserPayment } from "shared/api/subuser";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";
import { PERMISSIONS, ROUTE_NAME } from "shared/constants";
import { readableFormatDate} from "shared/utils";

const PaymentDetails = ({ data, Component, ...props }) => {
  const [spin, setSpin] = useState(false);
  const [verifyPaymentModel, setVerifyPayment] = useState(false);

  const handleVerifyPaymentCallback = useCallback((sts) => {
    if (sts) {
      window.location.reload();
    }
    setVerifyPayment(false);
  },[]);
  const verifySubuserPayment = () => {
    setVerifyPayment(true);
    // setSpin(true);
    // let ref = data.subuser_payment_reference_number;
    // verifySubUserPayment(ref).then((res) => {
    //   if (res && res.success) {
    //     toastSuccess("Verified Successfully");
    //   } else {
    //     toastError(res.message);
    //   }
    //   window.location.reload();
    // });
  };

  return (
    <Spin spinning={spin}>
      <Card>
        <CardContent className="card-content_head">
          <Grid container>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              Subuser Payment Details
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Grid
                container
                spacing={1}
                // alignItems="center"
                justifyContent="flex-end"
              >
                {data["payment_status"] === "NOT_PAID" && (
                  <Grid item>
                    <KisshtButton
                      route={ROUTE_NAME.subuser_payment}
                      permission={PERMISSIONS.subuser_payment.verify_subuser_payment}
                      onClick={verifySubuserPayment}
                      className="common_kissht_btn"
                    >
                      Verify Subuser Payment
                    </KisshtButton>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <CustomTableWrapper>
            <Grid item lg={6} md={6} sm={12} xs={12}>
            <TableContainer className="common_X_scroll">
              <Table className="w-full">
                <TableBody>
                  <TableBodyCell className="common_table_title">
                    Subuser Payment Reference Number
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["subuser_payment_reference_number"]}
                  </TableBodyCell>
                </TableBody>

                <TableBody>
                  <TableBodyCell className="common_table_title">Payment Amount</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    <RobotFont type="medium">₹</RobotFont>
                    {data["payment_amount"]}
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Payment Status</TableBodyCell>
                  <TableBodyCell>
                    <BootstrapBadge text={data["payment_status"]} />
                  </TableBodyCell>
                </TableBody>

                {/* <TableBody>
                    <TableBodyCell>Payment Reason</TableBodyCell>
                    <TableBodyCell>
                      {data["payment_request_reason"]}
                    </TableBodyCell>
                  </TableBody> */}
                {/* <TableBody>
                    <TableBodyCell>Payment Receipt Mode / Source</TableBodyCell>
                    <TableBodyCell>
                      {`${data["payment_receipt_mode"]} / ${
                        data["payment_receipt_source"]
                          ? data["payment_receipt_source"]
                          : "-"
                      }`}
                    </TableBodyCell>
                  </TableBody> */}
                {/* <TableBody>
                    <TableBodyCell>Payment Status</TableBodyCell>
                    <TableBodyCell>
                      <BootstrapBadge text={data["payment_status"]} />
                    </TableBodyCell>
                  </TableBody> */}
                <TableBody>
                  <TableBodyCell className="common_table_title">Payment Receipt Date</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["payment_receipt_date"])}
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Other Data</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {JSON.stringify(data["other_data"])}
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Payment Receipt Mode</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["payment_receipt_mode"]}
                  </TableBodyCell>
                </TableBody>
              </Table>
              </TableContainer>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
            <TableContainer className="common_X_scroll">
              <table className="w-full">
                <TableBody>
                  <TableBodyCell className="common_table_title">Payment Receipt Source</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["payment_receipt_source"]}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Subuser Name</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["subuser_name"]}</TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Subuser Reference Number</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["subuser_reference_number"]}
                  </TableBodyCell>
                </TableBody>

                <TableBody>
                  <TableBodyCell className="common_table_title">Payment Initiate Source</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["payment_initiate_source"]}
                  </TableBodyCell>
                </TableBody>

                <TableBody>
                  <TableBodyCell className="common_table_title">Created At</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["created_at"])}
                  </TableBodyCell>
                </TableBody>
                <TableBody>
                  <TableBodyCell className="common_table_title">Updated At</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["updated_at"])}
                  </TableBodyCell>
                </TableBody>
              </table>
              </TableContainer> 
            </Grid>
          </CustomTableWrapper>
        </CardContent>
      </Card>
      {data["payment_receipt_mode_data"] && (
        <Component
          data={data["payment_receipt_mode_data"]}
          payment_ref_no={data["subuser_payment_reference_number"]}
          setSpin={setSpin}
        />
      )}
      <KisshtDialog
        // maxWidth="sm"
        title="Verify Payment"
        open={verifyPaymentModel}
        handleClose={handleVerifyPaymentCallback}
      >
        <VerifyPayment api={verifySubUserPayment} handleClose={handleVerifyPaymentCallback} paymentRef={data['subuser_payment_reference_number']} />
      </KisshtDialog>
    </Spin>
  );
};

export default PaymentDetails;
